import React from 'react';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '3rem 1.5rem',
      textAlign: 'center',
      gap: '0.75rem',
    }}>
      {icon && (
        <div style={{ color: 'var(--color-text-faint)', marginBottom: '0.5rem' }}>
          {icon}
        </div>
      )}
      <p style={{ fontWeight: 600, color: 'var(--color-text)', fontSize: 'var(--text-md)' }}>{title}</p>
      {description && (
        <p style={{ color: 'var(--color-text-muted)', fontSize: 'var(--text-sm)', maxWidth: '360px' }}>{description}</p>
      )}
      {action && <div style={{ marginTop: '0.5rem' }}>{action}</div>}
    </div>
  );
}
